export const obscureCNPJ = (cnpj: string) =>
  cnpj.substring(0, 5) +
  cnpj.substring(5, cnpj.length - 7).replace(/\d/g, '*') +
  cnpj.substring(cnpj.length - 7);
